// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var CardV5 = require("../common/Components/CardV5.bs.js");
var FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var RelayEnv = require("../../RelayEnv.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var Heading__Jsx3 = require("../../uikit/reason/helpers/Heading__Jsx3.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var AccountMemberUtils = require("./AccountMemberUtils.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var SubusersAddUserFormQuery_graphql = require("../../__generated__/SubusersAddUserFormQuery_graphql.bs.js");
var SubusersAddUserForm_account_graphql = require("../../__generated__/SubusersAddUserForm_account_graphql.bs.js");
var SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");
var SubusersAddUserForm_AddMemberV5Mutation_graphql = require("../../__generated__/SubusersAddUserForm_AddMemberV5Mutation_graphql.bs.js");

var convertVariables = SubusersAddUserFormQuery_graphql.Internal.convertVariables;

var convertResponse = SubusersAddUserFormQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = SubusersAddUserFormQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, SubusersAddUserFormQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, SubusersAddUserFormQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(SubusersAddUserFormQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(SubusersAddUserFormQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(SubusersAddUserFormQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(SubusersAddUserFormQuery_graphql.node, convertVariables);

var Query_emailRegistrationStatus_decode = SubusersAddUserFormQuery_graphql.Utils.emailRegistrationStatus_decode;

var Query_emailRegistrationStatus_fromString = SubusersAddUserFormQuery_graphql.Utils.emailRegistrationStatus_fromString;

var Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function validate(email) {
  var val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
          email: email
        }, undefined, "network-only");
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return {
              TAG: "Error",
              _0: "something went wrong"
            };
    }
    throw exn;
  }
  var match = val.emailRegistrationStatus;
  if (match === undefined) {
    return {
            TAG: "Error",
            _0: "email is not available"
          };
  }
  var tmp = match.status;
  if ((tmp === "AVAILABLE" || tmp === "REGISTERED") && tmp === "AVAILABLE") {
    return {
            TAG: "Ok",
            _0: undefined
          };
  } else {
    return {
            TAG: "Error",
            _0: "email is not available"
          };
  }
}

var ValidateEmailAsync = {
  Query: Query,
  validate: validate
};

function SubusersAddUserForm$SubuserLimitReachedMessage(props) {
  return JsxRuntime.jsx(CardV5.make, {
              children: JsxRuntime.jsx(Heading__Jsx3.make, {
                    as_: "h5",
                    children: "You have reached the maximum number of allowed users. Contact support if you need to add more users to this account."
                  })
            });
}

var SubuserLimitReachedMessage = {
  make: SubusersAddUserForm$SubuserLimitReachedMessage
};

function SubusersAddUserForm$OnlyAccountOwnerMessage(props) {
  return JsxRuntime.jsx(CardV5.make, {
              children: JsxRuntime.jsx(Heading__Jsx3.make, {
                    as_: "h5",
                    children: "Only the account owner can add users to the account."
                  })
            });
}

var OnlyAccountOwnerMessage = {
  make: SubusersAddUserForm$OnlyAccountOwnerMessage
};

var convertFragment = SubusersAddUserForm_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersAddUserForm_account_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersAddUserForm_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, SubusersAddUserForm_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersAddUserForm_account_graphql.node, convertFragment, fRef);
}

var AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables$1 = SubusersAddUserForm_AddMemberV5Mutation_graphql.Internal.convertVariables;

var convertResponse$1 = SubusersAddUserForm_AddMemberV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = SubusersAddUserForm_AddMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, SubusersAddUserForm_AddMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, SubusersAddUserForm_AddMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var AddMemberV5Mutation_accountMemberRoleInput_decode = SubusersAddUserForm_AddMemberV5Mutation_graphql.Utils.accountMemberRoleInput_decode;

var AddMemberV5Mutation_accountMemberRoleInput_fromString = SubusersAddUserForm_AddMemberV5Mutation_graphql.Utils.accountMemberRoleInput_fromString;

var AddMemberV5Mutation = {
  accountMemberRoleInput_decode: AddMemberV5Mutation_accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: AddMemberV5Mutation_accountMemberRoleInput_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$2
};

var genericErrorMessage = "Something went wrong when adding the user. Please try again or contact our support.";

var validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var lastName = Form__Helpers.noneIfEmpty(param.lastName);
      if (lastName !== undefined) {
        return {
                TAG: "Ok",
                _0: lastName
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var firstName = Form__Helpers.noneIfEmpty(param.firstName);
      if (firstName !== undefined) {
        return {
                TAG: "Ok",
                _0: firstName
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators_email = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var email = Form__Helpers.noneIfEmpty(param.email);
      if (email === undefined) {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
      var email$1 = Scalars.EmailAddress.validate(email);
      if (email$1.TAG === "Ok") {
        return {
                TAG: "Ok",
                _0: email$1._0
              };
      } else {
        return {
                TAG: "Error",
                _0: "Please enter a valid email."
              };
      }
    }),
  validateAsync: Formality__Debouncer.make(700, (function (param) {
          var dispatch = param[2];
          var value = param[0];
          var validate = function (email, param) {
            return param.validateEmail(Scalars.EmailAddress.toString(email)).then(function (res) {
                        if (res.TAG === "Ok") {
                          return {
                                  TAG: "Ok",
                                  _0: email
                                };
                        } else {
                          return {
                                  TAG: "Error",
                                  _0: res._0
                                };
                        }
                      });
          };
          Formality.Async.validateAsyncWithMetadata(value, param[1], validate, (function (res) {
                  dispatch({
                        TAG: "ApplyAsyncResultForEmailField",
                        _0: value,
                        _1: res
                      });
                }));
        })),
  eq: Caml_obj.equal
};

var validators_role = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var role = param.role;
      if (role !== undefined) {
        return {
                TAG: "Ok",
                _0: role
              };
      } else {
        return {
                TAG: "Error",
                _0: "is required"
              };
      }
    })
};

var validators = {
  lastName: validators_lastName,
  firstName: validators_firstName,
  email: validators_email,
  role: validators_role
};

function initialFieldsStatuses(_input) {
  return {
          lastName: "Pristine",
          firstName: "Pristine",
          email: "Pristine",
          role: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            lastName: "Pristine",
            firstName: "Pristine",
            email: "Pristine",
            role: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.lastName;
  var tmp;
  tmp = typeof match !== "object" ? validators.lastName.validate(input, metadata) : match._0;
  var match$1 = fieldsStatuses.firstName;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.firstName.validate(input, metadata) : match$1._0;
  var value = fieldsStatuses.email;
  var tmp$2;
  tmp$2 = typeof value !== "object" ? ({
        NAME: "Result",
        VAL: validators.email.validate(input, metadata)
      }) : (
      value.TAG === "Dirty" ? ({
            NAME: "Result",
            VAL: value._0
          }) : ({
            NAME: "Validating",
            VAL: value._0
          })
    );
  var match$2 = fieldsStatuses.role;
  var tmp$3;
  tmp$3 = typeof match$2 !== "object" ? validators.role.validate(input, metadata) : match$2._0;
  var lastNameResult = tmp;
  var exit = 0;
  var emailResult = tmp$2;
  if (typeof emailResult === "object") {
    if (emailResult.NAME === "Validating") {
      return {
              TAG: "Validating",
              fieldsStatuses: {
                lastName: {
                  TAG: "Dirty",
                  _0: lastNameResult,
                  _1: "Shown"
                },
                firstName: {
                  TAG: "Dirty",
                  _0: tmp$1,
                  _1: "Shown"
                },
                email: emailResult.NAME === "Result" ? ({
                      TAG: "Dirty",
                      _0: emailResult.VAL,
                      _1: "Shown"
                    }) : ({
                      TAG: "Validating",
                      _0: emailResult.VAL
                    }),
                role: {
                  TAG: "Dirty",
                  _0: tmp$3,
                  _1: "Shown"
                }
              },
              collectionsStatuses: undefined
            };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2 && lastNameResult.TAG === "Ok") {
    var firstNameResult = tmp$1;
    if (firstNameResult.TAG === "Ok") {
      var match$3 = tmp$2;
      if (typeof match$3 === "object" && match$3.NAME === "Result") {
        var emailResult$1 = match$3.VAL;
        if (emailResult$1.TAG === "Ok") {
          var roleResult = tmp$3;
          return {
                  TAG: "Valid",
                  output: {
                    role: roleResult._0,
                    email: emailResult$1._0,
                    firstName: firstNameResult._0,
                    lastName: lastNameResult._0
                  },
                  fieldsStatuses: {
                    lastName: {
                      TAG: "Dirty",
                      _0: lastNameResult,
                      _1: "Shown"
                    },
                    firstName: {
                      TAG: "Dirty",
                      _0: firstNameResult,
                      _1: "Shown"
                    },
                    email: {
                      TAG: "Dirty",
                      _0: emailResult$1,
                      _1: "Shown"
                    },
                    role: {
                      TAG: "Dirty",
                      _0: roleResult,
                      _1: "Shown"
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        
      }
      
    }
    
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            lastName: {
              TAG: "Dirty",
              _0: lastNameResult,
              _1: "Shown"
            },
            firstName: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            email: {
              TAG: "Dirty",
              _0: tmp$2.VAL,
              _1: "Shown"
            },
            role: {
              TAG: "Dirty",
              _0: tmp$3,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurLastNameField" :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lastName, validators_lastName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  lastName: status,
                                  firstName: init.firstName,
                                  email: init.email,
                                  role: init.role
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurFirstNameField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  lastName: init.lastName,
                                  firstName: status,
                                  email: init.email,
                                  role: init.role
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurEmailField" :
                  var result$2 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: status,
                                  role: init.role
                                };
                        }));
                  if (result$2 === undefined) {
                    return "NoUpdate";
                  }
                  var value = result$2.email;
                  if (typeof value === "object" && value.TAG !== "Dirty") {
                    var value$1 = value._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators_email.validateAsync([
                                      value$1,
                                      metadata,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: result$2,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case "BlurRoleField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.role, validators_role, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  role: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  switch (match$1.TAG) {
                    case "Valid" :
                        var output = match$1.output;
                        var error = state.formStatus;
                        var tmp;
                        tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                        return {
                                TAG: "UpdateWithSideEffects",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: {
                                    TAG: "Submitting",
                                    _0: tmp
                                  },
                                  submissionStatus: "AttemptedToSubmit"
                                },
                                _1: (function (param) {
                                    var dispatch = param.dispatch;
                                    onSubmit(output, {
                                          notifyOnSuccess: (function (input) {
                                              dispatch({
                                                    TAG: "SetSubmittedStatus",
                                                    _0: input
                                                  });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              dispatch({
                                                    TAG: "SetSubmissionFailedStatus",
                                                    _0: error
                                                  });
                                            }),
                                          reset: (function () {
                                              dispatch("Reset");
                                            }),
                                          dismissSubmissionResult: (function () {
                                              dispatch("DismissSubmissionResult");
                                            })
                                        });
                                  })
                              };
                    case "Invalid" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: "Editing",
                                  submissionStatus: "AttemptedToSubmit"
                                }
                              };
                    case "Validating" :
                        return {
                                TAG: "Update",
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: state.formStatus,
                                  submissionStatus: state.submissionStatus
                                }
                              };
                    
                  }
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateLastNameField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            lastName: status,
                                            firstName: init.firstName,
                                            email: init.email,
                                            role: init.role
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateFirstNameField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            lastName: init.lastName,
                                            firstName: status,
                                            email: init.email,
                                            role: init.role
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateEmailField" :
                  var nextInput$2 = action._0(state.input);
                  var nextFieldsStatuses = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$2, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: status,
                                  role: init.role
                                };
                        }));
                  var value$2 = nextFieldsStatuses.email;
                  if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
                    var value$3 = value$2._0;
                    return {
                            TAG: "UpdateWithSideEffects",
                            _0: {
                              input: nextInput$2,
                              fieldsStatuses: nextFieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                validators_email.validateAsync([
                                      value$3,
                                      metadata,
                                      param.dispatch
                                    ]);
                              })
                          };
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: nextFieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateRoleField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.role, state.submissionStatus, validators_role, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            lastName: init.lastName,
                                            firstName: init.firstName,
                                            email: init.email,
                                            role: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "ApplyAsyncResultForEmailField" :
                  var validator = validators_email;
                  var x = state.fieldsStatuses.email;
                  if (typeof x !== "object") {
                    return "NoUpdate";
                  }
                  if (x.TAG === "Dirty") {
                    return "NoUpdate";
                  }
                  if (!validator.eq(x._0, action._0)) {
                    return "NoUpdate";
                  }
                  var init = state.fieldsStatuses;
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: {
                              lastName: init.lastName,
                              firstName: init.firstName,
                              email: {
                                TAG: "Dirty",
                                _0: action._1,
                                _1: "Shown"
                              },
                              role: init.role
                            },
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                lastName: "Pristine",
                                firstName: "Pristine",
                                email: "Pristine",
                                role: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                lastName: "Pristine",
                                firstName: "Pristine",
                                email: "Pristine",
                                role: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateLastName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateLastNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateFirstName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateFirstNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateEmail: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateEmailField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateRole: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateRoleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurLastName: (function () {
              dispatch("BlurLastNameField");
            }),
          blurFirstName: (function () {
              dispatch("BlurFirstNameField");
            }),
          blurEmail: (function () {
              dispatch("BlurEmailField");
            }),
          blurRole: (function () {
              dispatch("BlurRoleField");
            }),
          lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
          firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
          emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
          roleResult: Formality.exposeFieldResult(state.fieldsStatuses.role),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.lastName;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.firstName;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.email;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.role;
              if (typeof tmp$3 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              switch (match.TAG) {
                case "Valid" :
                    return true;
                case "Invalid" :
                    return false;
                case "Validating" :
                    return ;
                
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function SubusersAddUserForm$AddUserForm(props) {
  var accountDataId = props.accountDataId;
  var match = use$2();
  var addMember = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setRegisteredEmail = match$1[1];
  var form = useForm({
        role: undefined,
        email: undefined,
        firstName: undefined,
        lastName: undefined
      }, {
        validateEmail: validate
      }, (function (output, param) {
          var notifyOnFailure = param.notifyOnFailure;
          var notifyOnSuccess = param.notifyOnSuccess;
          addMember({
                connections: [SubusersPageAccountsList_account_graphql.makeConnectionId(accountDataId)],
                input: {
                  email: output.email,
                  firstName: output.firstName,
                  lastName: output.lastName,
                  role: output.role
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var addMemberV5 = param.addMemberV5;
                  if (addMemberV5 === undefined) {
                    return notifyOnFailure(genericErrorMessage);
                  }
                  switch (addMemberV5.__typename) {
                    case "AccountMemberAdded" :
                        setRegisteredEmail(function (param) {
                              return Scalars.EmailAddress.toString(output.email);
                            });
                        return notifyOnSuccess(undefined);
                    case "NotAuthorizedError" :
                        return notifyOnFailure("Only the account owner can add users to the account.");
                    case "SubuserLimitReachedForAccount" :
                        return notifyOnFailure("You have reached the maximum number of allowed users. Contact support if you need to add more users to this account.");
                    case "__unselected" :
                        return notifyOnFailure(genericErrorMessage);
                    
                  }
                }), undefined, undefined);
        }));
  var match$2 = form.roleResult;
  var tmp;
  tmp = match$2 !== undefined ? (
      match$2.TAG === "Ok" ? "Ok" : "Error"
    ) : undefined;
  var match$3 = form.firstNameResult;
  var tmp$1;
  tmp$1 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$3._0
      }) : undefined;
  var match$4 = form.lastNameResult;
  var tmp$2;
  tmp$2 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$4._0
      }) : undefined;
  var tmp$3 = true;
  if (!form.submitting) {
    var match$5 = form.status;
    var tmp$4;
    tmp$4 = typeof match$5 !== "object" ? (
        match$5 === "Editing" ? false : true
      ) : (
        match$5.TAG === "Submitting" ? true : false
      );
    tmp$3 = tmp$4;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                            status: form.status,
                            submissionErrorToString: (function (v) {
                                return v;
                              }),
                            onSuccessMessage: "An email with instructions has been sent to " + match$1[0],
                            resetForm: form.reset,
                            dismissSubmissionResult: form.dismissSubmissionResult
                          }),
                      className: "mb-5"
                    }),
                JsxRuntime.jsx(FormV5.FormGroup.make, {
                      label: "Role:",
                      children: JsxRuntime.jsx(AccountMemberUtils.RoleSelectComponent.make, {
                            onChange: (function (value) {
                                form.updateRole((function (formState, value) {
                                        return {
                                                role: value,
                                                email: formState.email,
                                                firstName: formState.firstName,
                                                lastName: formState.lastName
                                              };
                                      }), value !== undefined ? value.value : undefined);
                              }),
                            result: tmp,
                            value: Core__Option.map(form.input.role, (function (v) {
                                    return AccountMemberUtils.SelectOpts.make(v);
                                  }))
                          })
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Email:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              placeholderText: "Enter your email",
                              onChange: (function ($$event) {
                                  form.updateEmail((function (v, value) {
                                          return {
                                                  role: v.role,
                                                  email: value,
                                                  firstName: v.firstName,
                                                  lastName: v.lastName
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurEmail();
                                }),
                              disabled: false,
                              status: Form__Helpers.resultAsyncToStatus(form.emailResult),
                              value: Core__Option.getOr(form.input.email, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldErrorAsyncV2.make, {
                              valid: form.emailResult
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "First name:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateFirstName((function (v, value) {
                                          return {
                                                  role: v.role,
                                                  email: v.email,
                                                  firstName: value,
                                                  lastName: v.lastName
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurFirstName();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.firstNameResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.firstName, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$1
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Last name:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateLastName((function (v, value) {
                                          return {
                                                  role: v.role,
                                                  email: v.email,
                                                  firstName: v.firstName,
                                                  lastName: value
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurLastName();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.lastNameResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.lastName, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$2
                            })
                      ]
                    }),
                JsxRuntime.jsx(FormV5.FormGroup.make, {
                      children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                            onClick: (function (extra) {
                                return Form__Helpers.preventDefault(form.submit, extra);
                              }),
                            disabled: tmp$3 || match[1],
                            children: "Add user"
                          })
                    })
              ]
            });
}

var AddUserForm = {
  AddMemberV5Mutation: AddMemberV5Mutation,
  genericErrorMessage: genericErrorMessage,
  FormConfig: FormConfig,
  make: SubusersAddUserForm$AddUserForm
};

function SubusersAddUserForm(props) {
  var currentUserRole = props.currentUserRole;
  var account = use$1(props.account);
  var match = Core__Option.getOr(account.subuserLimitReached, false);
  if (match) {
    return JsxRuntime.jsx(SubusersAddUserForm$SubuserLimitReachedMessage, {});
  } else if (currentUserRole !== undefined && (currentUserRole === "TRANSACTION_COORDINATOR" || currentUserRole === "SHOWING_ASSISTANT" || currentUserRole === "PARTNER" || currentUserRole === "OWNER" || currentUserRole === "OPERATIONS_MANAGER" || currentUserRole === "MARKETING_SPECIALIST" || currentUserRole === "LISTING_SPECIALIST" || currentUserRole === "LISTING_MANAGER" || currentUserRole === "INSIDE_SALES_AGENT" || currentUserRole === "CLIENT_CARE_COORDINATOR" || currentUserRole === "BUYER_SPECIALIST" || currentUserRole === "ASSOCIATE" || currentUserRole === "ASSISTANT" || currentUserRole === "UNKNOWN") && currentUserRole === "OWNER") {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
                        children: "Add User"
                      }),
                  JsxRuntime.jsx(SubusersAddUserForm$AddUserForm, {
                        accountDataId: account.__id
                      })
                ],
                className: "mt-8"
              });
  } else {
    return JsxRuntime.jsx(SubusersAddUserForm$OnlyAccountOwnerMessage, {});
  }
}

var make = SubusersAddUserForm;

exports.ValidateEmailAsync = ValidateEmailAsync;
exports.SubuserLimitReachedMessage = SubuserLimitReachedMessage;
exports.OnlyAccountOwnerMessage = OnlyAccountOwnerMessage;
exports.AccountFragment = AccountFragment;
exports.AddUserForm = AddUserForm;
exports.make = make;
/* use Not a pure module */
